import { render, staticRenderFns } from "./ReportInspectionResultsIndex.vue?vue&type=template&id=40f47a36"
import script from "./ReportInspectionResultsIndex.vue?vue&type=script&lang=js"
export * from "./ReportInspectionResultsIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports